<script>
import Component from '~/sites/shop/pages/contact/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/kontakty',
      de: '/impressum',
      en: '/contact',
      sk: '/kontakty',
    },
  },
}
</script>
